enum UpdateOptions {
  CUSTOM = "custom",
  PRODUCT = "product",
  REWARD = "reward"
}

export default UpdateOptions
